/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_In_Desktop_ButtonInputs */



/**
* | output |
* | --- |
* | "Open in Desktop App" |
*
* @param {Open_In_Desktop_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_in_desktop_button = /** @type {((inputs?: Open_In_Desktop_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_In_Desktop_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir dans l'application de bureau")
	if (locale === "de") return /** @type {LocalizedString} */ ("In der Desktop-App öffnen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri nell'app desktop")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открыть в настольном приложении")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abrir en la aplicación de escritorio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在桌面应用程序中打开")
	if (locale === "ja") return /** @type {LocalizedString} */ ("デスクトップアプリで開く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डेस्कटॉप ऐप में खोलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abrir no aplicativo para desktop")
	return /** @type {LocalizedString} */ ("Open in Desktop App")
});